import { Badge, LinkOpenIcon } from '@thefarmersfront/kitchen';

import type { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';

import { formatDate } from '~/utils/date';

import {
  DATE_FORMAT,
  DELIVERY_AGENCY_SHIPPING_LABEL_STATUS_BADGE_COLOR,
  DELIVERY_AGENCY_TRACKING_LINKS,
} from '~/constants';

import type { TypeDeliveryAgencyOrderDetail } from '~/types/delivery-agency.types';

type TypeDeliveryAgencyOrderDetailDeliveryInfo = TypeDeliveryAgencyOrderDetail['shippingLabelInfoOutputs'][number];

const getDeliveryAgencyOrderDeliveryInfoColumnDefs = () => {
  const columnDefs: ColDef<TypeDeliveryAgencyOrderDetailDeliveryInfo>[] = [
    {
      field: 'shippingLabelNumber',
      headerName: '운송장 번호',
      width: 245,
    },
    {
      field: 'shippingLabelStatus',
      headerName: '운송장 상태',
      cellDataType: false,
      width: 100,
      cellRenderer: Badge,
      cellRendererParams: ({
        value,
      }: ICellRendererParams<
        TypeDeliveryAgencyOrderDetailDeliveryInfo,
        TypeDeliveryAgencyOrderDetailDeliveryInfo['shippingLabelStatus']
      >) => ({
        variant: 'light',
        status: true,
        color: value ? DELIVERY_AGENCY_SHIPPING_LABEL_STATUS_BADGE_COLOR[value.code] : undefined,
        children: value?.description,
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'statusUpdatedAt',
      headerName: '상태 마지막 업데이트 일시',
      width: 170,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<
        TypeDeliveryAgencyOrderDetailDeliveryInfo,
        TypeDeliveryAgencyOrderDetailDeliveryInfo['statusUpdatedAt']
      >) => formatDate(value, DATE_FORMAT.DATE_TIME) ?? '-',
    },
    {
      field: 'deliveryType.description',
      headerName: '배송 유형',
      width: 80,
    },
    {
      field: 'courierCode.description',
      headerName: '배송사',
      width: 88,
    },
    {
      field: 'shippingLabelNumber',
      headerName: '',
      minWidth: 298,
      flex: 1,
      cellRenderer: TextButtonCell,
      cellRendererParams: ({
        data,
      }: ICellRendererParams<
        TypeDeliveryAgencyOrderDetailDeliveryInfo,
        TypeDeliveryAgencyOrderDetailDeliveryInfo['shippingLabelNumber']
      >) => {
        const courierCode = data?.courierCode.code as keyof typeof DELIVERY_AGENCY_TRACKING_LINKS | undefined;
        const invoiceNumber = data?.shippingLabelNumber;
        const url =
          courierCode && invoiceNumber ? DELIVERY_AGENCY_TRACKING_LINKS[courierCode] + invoiceNumber : undefined;

        return {
          children: '배송조회',
          size: 'tiny',
          variant: 'normal',
          target: '_blank',
          href: url,
          rightIcon: <LinkOpenIcon size={16} color="#672091" />,
        };
      },
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyOrderDeliveryInfoColumnDefs;
